import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapperProfessionalSection: css`
    display: flex;
  `,

  wrapperText: ({ spacing }) => css`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    p {
      margin-left: ${spacing.xs};
      margin-bottom: 0;
    }
  `,
})

export default useStyles
